var _defs, _polygon, _polygon2, _polygon3, _polygon4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmerald(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:#000;stroke-linejoin:round;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "29.68 5.31 83.48 5.31 94.71 16.63 94.82 93.48 83.99 104.6 29.48 104.6 18.56 93.73 18.56 16.22 29.68 5.31"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "23.04 18.76 33.36 9.92 80.17 9.92 90.59 19.03 90.32 91.06 80.55 100.33 32.97 100.33 23.04 91.39 23.04 18.76"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "27.25 21.27 36.47 14.01 77.06 13.85 86.12 21.27 85.96 88.71 76.95 96.13 36.08 96.13 27.25 89.04 27.25 21.27"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "31.06 23.45 39.25 17.62 74.22 17.62 82.08 23.45 82.08 86.48 73.84 92.53 38.87 92.53 31.06 86.64 31.06 23.45"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 18.56,
    y1: 16.22,
    x2: 31.06,
    y2: 23.45
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 29.68,
    y1: 5.31,
    x2: 39.25,
    y2: 17.62
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 83.48,
    y1: 5.31,
    x2: 74.22,
    y2: 17.62
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 82.08,
    y1: 23.45,
    x2: 94.71,
    y2: 16.63
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 94.82,
    y1: 93.48,
    x2: 82.08,
    y2: 86.48
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 73.84,
    y1: 92.53,
    x2: 83.99,
    y2: 104.6
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 38.87,
    y1: 92.53,
    x2: 29.48,
    y2: 104.6
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 18.56,
    y1: 93.73,
    x2: 31.06,
    y2: 86.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmerald);
export default __webpack_public_path__ + "static/media/emerald.6329586050c5e8120bf4670332509165.svg";
export { ForwardRef as ReactComponent };